import Swal from 'sweetalert2'
import {IPermissionsModel, IPermission} from '../../modules/auth/models/PermissionsModel'
import {hasPermission} from '../../modules/utils/UserPermissions '
import {IInventoryOfSupplier} from '../auth/models/InventoryOfSupplierModel'
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import moment from 'moment';
import _ from 'lodash';
import { IOrderProduct } from '../../models/OrderModel';
import { PD_EDITABLE_STATUS } from '../../constants/common';

export const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast: any) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export const Confirm = Swal.mixin({
  position: 'center',
  showConfirmButton: true,
  showCancelButton: true,
})

export const ToastConfirm = Swal.mixin({
  toast: true,
  position: 'center',
  showConfirmButton: true,
})

export const download = (data: Blob, name: string, format: string = 'xlsx') => {
  let url = ''
  if (data instanceof Blob) {
    url = URL.createObjectURL(data)
  } else {
    url = URL.createObjectURL(new Blob([data]))
  }
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `${name}.${format}`)
  document.body.appendChild(link)
  link.click()

  setTimeout(() => {
    link.removeAttribute('href')
    link.removeAttribute('download')
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }, 100)
}

export const checkPermissions = (userPermissions: IPermission[]): IPermissionsModel => {
  return {
    canView: hasPermission(userPermissions, 'view'),
    canCreate: hasPermission(userPermissions, 'create'),
    canUpdate: hasPermission(userPermissions, 'update'),
    canDelete: hasPermission(userPermissions, 'delete'),
  }
}

export const roundNumber = (number: number, decimals: number = 5) => {
  // if (isNaN(number)) {
  //   return 0
  // }
  const factor = Math.pow(10, decimals)
  return Math.round(number * factor) / factor
}

export const getBestSupplier = (inventoryOfSupplier: Array<IInventoryOfSupplier>) => {
  return inventoryOfSupplier.reduce((result: any, item: IInventoryOfSupplier) => {
    let minPrice = result.length ? result[0].price_sell : item.price_sell
    let priceSell = item?.price_sell ?? 0
    if (priceSell < minPrice) {
      minPrice = item.price_sell
      result.length = 0
    }

    if (item.price_sell === minPrice) {
      result = {...item}
    }

    return result
  }, {})
}

export const convertDotNotationToObject = (dotNotationObj: {[key: string]: any}) => {
  const resultObj = {}

  Object.keys(dotNotationObj).forEach((key) => {
    const value = dotNotationObj[key]
    const keyParts = key.split('.')
    let currentPart: {[key: string]: any} = resultObj

    for (let i = 0; i < keyParts.length - 1; i++) {
      const part = keyParts[i]
      if (!currentPart[part]) currentPart[part] = {}
      currentPart = currentPart[part]
    }

    currentPart[keyParts[keyParts.length - 1]] = value
  })

  return resultObj
}

export const getDiscount = (price: number, suggestedPrice: number) => {
  let discount = 0
  if (price !== 0 || suggestedPrice !== 0) {
    discount = suggestedPrice - price
  }
  return roundNumber((discount / suggestedPrice) * 100, 6) >= 0
    ? roundNumber((discount / suggestedPrice) * 100, 6)
    : 0
}

export const htmlToCanvas = async (htmlContent: any, name: string, format: string) => {
    const container = document.createElement("div");
    container.style.position = "fixed";
    container.style.width = "80mm";
    container.style.left = "-9999px"; // keep off-screen
    container.innerHTML = htmlContent;
    document.body.appendChild(container);
    
    // Convert HTML to canvas
    const canvas = await html2canvas(container, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");
  
    // PDF size: 80mm width, dynamic height
    const pdfWidth = 80; // mm
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    let formatSize: any = 'a4';
    if (format === 'tp80') {
      formatSize = [pdfWidth, pdfHeight];
    }
    const pdf = new jsPDF("p", "mm", formatSize);
    pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`${name}.pdf`);
    setTimeout(() => {
      document.body.removeChild(container);
    }, 100)
};

export const qrPdf = async (htmlContent: any, name: string, format: string) => {
  // Tạo container 80mm
  const container = document.createElement("div");
  container.style.position = "fixed";
  container.style.width = "80mm";
  container.style.left = "-9999px"; // keep off-screen
  container.innerHTML = htmlContent;
  document.body.appendChild(container);

  // Chụp thành canvas
  const canvas = await html2canvas(container, { scale: 2, useCORS: true });
  const imgData = canvas.toDataURL("image/png");

  const pdfWidth = 80; // mm
  const pdfPageHeight = 100; // mm mỗi trang (có thể chỉnh dài hơn)
  const pdf = new jsPDF("p", "mm", [pdfWidth, pdfPageHeight]);

  // Quy đổi mm → pixel
  const pageHeightPx = (canvas.width * pdfPageHeight) / pdfWidth;
  let position = 0;
  const overlap = 2;
  while (position < canvas.height) {
    // Tạo canvas cho từng phần trang
    const pageCanvas = document.createElement("canvas");
    pageCanvas.width = canvas.width;
    pageCanvas.height = Math.min(pageHeightPx, canvas.height - position);

    const ctx = pageCanvas.getContext("2d");
    ctx?.drawImage(
      canvas,
      0,
      position,
      canvas.width,
      pageCanvas.height,
      0,
      0,
      canvas.width,
      pageCanvas.height
    );

    const pageImgData = pageCanvas.toDataURL("image/png");
    const pageHeightMM = (pageCanvas.height * pdfWidth) / canvas.width;

    if (position === 0) {
      pdf.addImage(pageImgData, "PNG", 0, 1, pdfWidth, pageHeightMM);
    } else {
      pdf.addPage([pdfWidth, pdfPageHeight]);
      pdf.addImage(pageImgData, "PNG", 0, 1, pdfWidth, pageHeightMM);
    }
    position += pageHeightPx;
  }

  pdf.save(`${name}.pdf`);
  setTimeout(() => {
    document.body.removeChild(container);
  }, 100)
};

export const isMoreThanHoursAgo = (inputDatetime: string | undefined, hours: number) => {
  if (!inputDatetime) {
    return false
  }
  return moment().subtract(hours, 'hours').isAfter(inputDatetime)
}

export const hasDuplicates = (arr: any[]) => {
  return _.uniq(arr).length !== arr.length; 
}

export const getDefaultPriceAgency = (product: IOrderProduct) => {
    return {
        price: product.price,
        market_price: product.price,
        discount: 0
    }
}

export const isPdEditAble = (status: string) => {
  return PD_EDITABLE_STATUS.includes(status)
}